import { IAppState } from '../../../AppModulesWrapper';

import { EServiceId } from '../../types/reducers/publishTerms';

/**
 *
 * Возвращает id услуги, которая отображается внутри карточки ставки
 */
export function selectPromotionServiceId(state: IAppState): EServiceId | null {
  return state.servicePickerWidget.publishTerms.promotionServiceId;
}
